var BaseView = require('../components/accordion-list/director');

module.exports = BaseView.extend({
  views: {},
  Views: {
    facebookAlbums: require('./social-media-contents/facebook-albums'),
    facebookPages: require('./social-media-contents/facebook-pages'),
    instagram: require('./social-media-contents/instagram'),
    // flickr:         require('./social-media-contents/flickr'),
    gdrive: require('./social-media-contents/gdrive'),
    dropbox: require('./social-media-contents/dropbox'),
    assetbank: require('./social-media-contents/assetbank')
  },
  buttons: [],

  events: {
    'click dt > a:not([data-key="add"]):not([data-key="search"])': 'listContentToggleEvent'
  },

  loadListContent: function (key) {
    if (!key) {
      return;
    }

    var $button = this.$el.find('dt a[data-key="' + key + '"]');
    var view = BaseView.prototype.loadListContent.apply(this, arguments);

    view.on('no_access', function () {
      $button.addClass('blink');
    });

    return view;
  },

  listContentToggleEvent: function (event) {
    var $button = $(event.currentTarget);
    var $container = $button.closest('dt');
    var key = $button.data('key');

    this.views[key] || this.loadListContent(key);

    if (!$container.hasClass('active') && this.views[key].authenticate) {
      $button.removeClass('blink');
      this.views[key].authenticate().then(_.bind(_listContentToggleEvent, this));
    } else {
      _listContentToggleEvent.call(this);
    }

    function _listContentToggleEvent () {
      BaseView.prototype.listContentToggleEvent.call(this, event);

      var isActive = $container.hasClass('active');
      toggleGlobalScroll.call(this, !isActive);
      toggleImport.call(this, isActive);
    }

    function toggleImport (isActive) {
      if (isActive) {
        this.$el.siblings().css('visibility', 'hidden');
      } else {
        var hasOpenSubView = !$button.children('.back').is('.hidden');
        hasOpenSubView || _.delay(_.bind(function () {
          this.$el.siblings().hide();
          this.$el.siblings().css('visibility', '');
          this.$el.siblings().fadeIn();
        }, this), 200);
      }
    }

    function toggleGlobalScroll (display) {
      var $target = this.$el.parents('.add').children('.antiscroll-inner');

      display && $target.css('overflow', 'auto')
        .siblings('.antiscroll-scrollbar').show();

      display || $target.css('overflow', 'hidden')
        .siblings('.antiscroll-scrollbar').hide();
    }
  },

  refresh: function () {
    for (var key in this.views) {
      this.views[key].masonryReload();
    }
  },

  initialize: function (opts) {
    opts = opts || {};

    this.buttons = _.union(this.buttons, [
      {
        key: 'facebookAlbums',
        tag: 'tool.images.facebook_albums'
      },
      {
        key: 'facebookPages',
        tag: 'tool.images.facebook_pages'
      },
      // {
      //   key: 'instagram',
      //   tag: 'social.instagram'
      // },
      // {
      //   key: 'flickr',
      //   tag: 'social.flickr'
      // },
      {
        key: 'gdrive',
        tag: 'tool.images.gdrive',
        disabled: !INKIVE.C.USER.IS_SUPER
      },
      {
        key: 'dropbox',
        tag: 'tool.images.dropbox'
      }
    ]);

    if (opts.isAssetBankCompany) {
      this.buttons.push({
        key: 'assetbank',
        tag: 'tool.images.assetbank'
      });
      this.$el.css('height', 220);
    }

    BaseView.prototype.initialize.call(this);
  },

  render: function () {
    this.$el.html(this.template({ buttons: this.buttons }));
  }
});
